import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import { shortenAddress } from '@/utils/shortenAddress'
import { formatDateString } from '@/utils/formatting'

const VotesOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    return (
        <div>
            {artData && (
                <div>
                    <ul>
                        {artData.votes.map((voteData) => (
                            <div key={'#vote-details-' + voteData.vote.id}>
                                <span className="gray">Vote&nbsp; #{voteData.vote.id}&nbsp;</span>
                                <span className="white">{parseFloat(voteData.vote.amount).toFixed(2)}</span>
                                <span className="gray">&nbsp;by&nbsp;</span>
                                <span className="white">
                                    {shortenAddress(voteData.vote.voteUser.walletAddress)}&nbsp;
                                </span>
                                <span className="gray">&nbsp;at&nbsp;</span>
                                <span className="white">{formatDateString(voteData.vote.createdAt)}&nbsp;</span>
                            </div>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default VotesOverview
